module.exports = __webpack_public_path__ + "img/mv--logo--sp.d5fe73ce.png";